
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";
import { RegularDayKey, RegularTimeSlot } from "./schedule-types";
import { addOneHour, generateSlotStarts } from "./schedule-utils";

class Props {
  open = prop<boolean>({ default: false, type: Boolean });
  day = prop<RegularDayKey>({
    required: true,
    type: String as PropType<RegularDayKey>
  });
  existingSlots = prop<RegularTimeSlot[]>({
    default: () => [],
    type: Array as PropType<RegularTimeSlot[]>
  });
  selectedStart = prop<string>({ default: "", type: String });
  slotStartHour = prop<number>({ default: 8, type: Number });
  slotEndHour = prop<number>({ default: 23, type: Number });
  slotIntervalMinutes = prop<number>({ default: 60, type: Number });
}

@Options({
  emits: [
    "update:open",
    "update:selectedStart",
    "confirm",
    "duplicate-rejected"
  ],
  watch: {
    open(value: boolean) {
      if (value) this.duplicateError = false;
    },
    selectedStart() {
      this.duplicateError = false;
    }
  }
})
export default class PickupTimePopover extends Vue.with(Props) {
  duplicateError = false;
  addOneHour = addOneHour;

  get slotStarts(): string[] {
    return generateSlotStarts(
      this.slotStartHour,
      this.slotEndHour,
      this.slotIntervalMinutes
    );
  }

  selectStart(value: string): void {
    this.$emit("update:selectedStart", value);

    const duplicate = this.existingSlots.some((slot) => slot.start === value);
    if (duplicate) {
      this.duplicateError = true;
      this.$emit("duplicate-rejected", value);
      return;
    }

    this.$emit("confirm", value);
    this.close();
  }

  close(): void {
    this.$emit("update:open", false);
  }

  testIdTime(value: string): string {
    return value.replace(":", "");
  }

  isExistingStart(value: string): boolean {
    return this.existingSlots.some((slot) => slot.start === value);
  }
}
